// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#reset-sensor-button {
  margin: 10px 0px;
}

#reset-sensor-text {
  text-align: center;
}

#list-of-sensors li:first-child {
  display: none;
}

#sensor-list-content ul li {
  padding: 2px !important;
  overflow: hidden !important;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
/* First span goes left */
#sensor-list-content ul li span:first-child {
  float: left;
  text-align: left;
}

/* Second span is centered */
#sensor-list-content ul li span:nth-child(2) {
  text-align: center;
}

/* Third span goes right */
#sensor-list-content ul li span:last-child {
  float: right;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/sensor-list/sensor-list.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,iDAAiD;AACnD;AACA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["#reset-sensor-button {\n  margin: 10px 0px;\n}\n\n#reset-sensor-text {\n  text-align: center;\n}\n\n#list-of-sensors li:first-child {\n  display: none;\n}\n\n#sensor-list-content ul li {\n  padding: 2px !important;\n  overflow: hidden !important;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 10px;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n/* First span goes left */\n#sensor-list-content ul li span:first-child {\n  float: left;\n  text-align: left;\n}\n\n/* Second span is centered */\n#sensor-list-content ul li span:nth-child(2) {\n  text-align: center;\n}\n\n/* Third span goes right */\n#sensor-list-content ul li span:last-child {\n  float: right;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
